module.exports = __webpack_public_path__ + "static/background-7ef055b9964e465ea1cad687034224f0.png";